import { render } from "./OptionsPopup.vue?vue&type=template&id=50965b63&scoped=true"
import script from "./OptionsPopup.vue?vue&type=script&lang=js"
export * from "./OptionsPopup.vue?vue&type=script&lang=js"

import "./OptionsPopup.vue?vue&type=style&index=0&id=50965b63&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50965b63"]])

export default __exports__